import { createHttpLink } from '@apollo/client';
import * as RouteConfigurationService from 'src/services/config/domain/RouteConfigurationService/RouteConfigurationService.client';
import { isServerSide } from 'src/utils/validators/isServerSide';

const createAPILink = () =>
    createHttpLink({
        uri:
            !isServerSide() && window.location.origin.includes(RouteConfigurationService.Domain.OriginIdentifier.ZILLOW)
                ? RouteConfigurationService.Domain.ApplicationRoute.PREFIXED_GRAPHQL_ENDPOINT
                : RouteConfigurationService.Domain.ApplicationRoute.PREFIXLESS_GRAPHQL_ENDPOINT,
    });

export { createAPILink };
